export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ステータスがみつかりません。さがしています…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたのステータスがおきにいりされました"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フォローされました"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ふるいつうちをみる"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["つうち"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["よんだ！"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたのステータスがリピートされました"])},
    "no_more_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["つうちはありません"])}
  }
}